import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCheckboxModule } from '@fi-shared/checkbox';
import { CheckboxListComponent } from './checkbox-list.component';

@NgModule({
    imports: [CommonModule, FiCheckboxModule],
    declarations: [CheckboxListComponent],
    exports: [CheckboxListComponent],
})
export class FiCheckboxListModule {}
